export const formatVariable = (
  value: string | boolean,
  resolvedType?: VariableResolvedDataType
) => {
  switch (resolvedType) {
    case 'BOOLEAN':
      return value === 'True' || value === 'true';
    default:
      return value;
  }
};
